import axios from '@/util/axios'
import { forEach } from '@/utils/collection'

function xhrRequest(requests, socketId, authOptions, authEndpoint, callback) {
    axios.post(authEndpoint,
        { ...{ socket_id: socketId, channel_name: Object.keys(requests) }, ...authOptions.params ?? {} })
        .then((response) => {
            callback(false, response)
        })
        .catch((error) => {
            callback(true, error.response)
        })
}

class BufferedAuthorizer {
    constructor(options) {
        this.options = { ...{ authDelay: 100 }, ...options }
        this.authOptions = options.authOptions || {}
        this.requests = {}
        this.setRequestTimeout()
    }

    /**
     * Add auth request to queue and execute after delay
     */
    add(channel, callback) {
        this.requests[channel] = callback
        if (!this.requestTimeout) {
            this.setRequestTimeout()
        }
    }

    /**
     * Set new delay and authenticate all queued requests after timeout
     */
    setRequestTimeout() {
        clearTimeout(this.requestTimeout)
        this.requestTimeout = setTimeout(() => {
            if (Object.keys(this.requests).length) {
                this.executeRequests()
                this.setRequestTimeout()
            } else {
                this.requestTimeout = null
            }
        }, this.options.authDelay || 0)
    }

    /**
     * Execute all queued auth requests
     */
    executeRequests() {
        const { requests } = this
        this.requests = {}
        xhrRequest(requests, this.options.socketId, this.authOptions, this.options.authEndpoint,
            (hasError, response) => {
                if (hasError) {
                    forEach(requests, (cb) => {
                        cb(
                            new Error(
                                `Unable to retrieve auth string from auth endpoint - received status: ${response.status}`,
                            ),
                            { auth: '' },
                        )
                    })
                    return
                }
                forEach(requests, (cb, channel) => {
                    if (!response.data.hasOwnProperty(channel)) {
                        cb(new Error(`Couldn't retrieve channel info`), { auth: '' })
                        return
                    }
                    if (response.data[channel].status !== 200) {
                        cb(
                            new Error(
                                `Couldn't retrieve authentication info. ${response.data[channel].status} Clients must be authenticated to join private or presence channels.`,
                            ),
                            { auth: '' },
                        )
                        return
                    }

                    cb(null, response.data[channel].data)
                })
            })
    }
}

/**
 * Add buffered authorizer to Pusher lib
 * Each endpoint and socket id gets its own buffered authorizer
 */
const authorizers = {}

export default function (channel, options) {
    return {
        authorize(socketId, callback) {
            const { authEndpoint } = options
            const key = `${socketId}:${authEndpoint}`

            let authorizer = authorizers[key]

            if (!authorizer) {
                authorizer = authorizers[key] = new BufferedAuthorizer({
                    socketId,
                    authEndpoint,
                    authDelay: options.authDelay,
                    authOptions: options.auth,
                })
            }
            authorizer.add(channel.name, callback)
        },
    }
}
